import '../css/style.scss'
import {Sound} from '../../shared/scripts/Sound'
import {UIMinimalHeaderController} from './ui_html/new_layout/UIMinimalHeaderController'
import {UISidebarController} from './ui_html/new_layout/UISidebarController'
import {EntryShared} from '../../shared/scripts/EntryShared'
import {UISingletonScrollController} from '../../shared/scripts/ui_scroll_controller/UISingletonScrollController'
import {EntrySingletonPageShared} from '../EntrySingletonPageShared'

void init()

async function init() {
    Sound.loadSounds()

    await EntryShared.initializeEntry()

    const headerController = new UIMinimalHeaderController()
    new UISidebarController()

    new UISingletonScrollController()

    EntrySingletonPageShared.initializeSocketAndGeneralServices(headerController)
}
